module.exports = __webpack_public_path__ + "media/flags/cl-f6e198b7.svg";